"use client";

/**
 * Best-effort page screenshot for issue reports: renders the DOM to a PNG
 * (html-to-image, lazy-loaded so it never enters the main bundle), excluding
 * the tutor widget itself so the shot shows the page under discussion.
 * Returns raw base64 (no data-URL prefix), or undefined when capture fails
 * or the image is too large - the report is sent without it either way.
 */
const MAX_BASE64_LENGTH = 3_000_000; // ~2.2 MB binary

export async function captureScreenshot(): Promise<string | undefined> {
  try {
    const { toPng } = await import("html-to-image");
    const dataUrl = await toPng(document.body, {
      pixelRatio: 1, // device pixel ratio would triple the size on phones
      filter: (node) => !(node instanceof Element && node.hasAttribute("data-agent-widget")),
    });
    const base64 = dataUrl.split(",")[1];
    if (!base64 || base64.length > MAX_BASE64_LENGTH) return undefined;
    return base64;
  } catch {
    return undefined;
  }
}
